import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { AnalogClock } from "@components/Clocks/AnalogClock";
import { DigitalClock } from "@components/Clocks/DigitalClock";
import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";
dayjs.extend(advancedFormat);

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ isAnalog = false, isPreview = true }) =>
    isAnalog
      ? isPreview
        ? `rgba(43, 47, 50, 0.5)`
        : "transparent"
      : `rgba(43, 47, 50, 1)`};
  border-radius: 12px;
  overflow: hidden;
`;

export const WidgetTime = ({ attribute, isPreview = true }) => {
  console.log("isPreview :>> ", isPreview);
  const containerRef = useRef(null);
  const format = _.get(attribute, ["format"]);
  const clockType = _.get(attribute, ["clockType"]);

  const [fontSize, setFontSize] = useState(16);
  const [isFontSizeReady, setIsFontSizeReady] = useState(false);

  const updateFontSize = () => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect();
      const newFontSize = Math.min(width, height) * 0.2;
      setFontSize(newFontSize);
      setIsFontSizeReady(true);
    }
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(updateFontSize);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    updateFontSize();

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, [attribute]);

  return (
    <Container
      ref={containerRef}
      isAnalog={clockType === "ANALOG"}
      isPreview={isPreview}
    >
      {/* // digital */}
      {clockType === "DIGITAL" && isFontSizeReady && (
        // <Text
        //   fontFamily="NotoSansThaiLooped"
        //   color={COLOR_WHITE}
        //   fontWeight="600"
        //   style={{ fontSize: `${fontSize}px`, whiteSpace: "nowrap" }}
        // >
        //   {digitalTime}
        // </Text>
        <DigitalClock fontSize={fontSize} attribute={attribute} />
      )}
      {/* // digital */}

      {/* analog */}
      {clockType === "ANALOG" && isFontSizeReady && (
        <AnalogClock fontSize={fontSize} attribute={attribute} />
      )}
      {/* analog */}
    </Container>
  );
};
